import { AxiosInstance } from "axios";
import TokenHelper from "../utils/tokenHelper";

export const basePath = "/cloud-me-up";

// Paths for all endpoints.
export const cloudinaryWeserveApiPaths = {
  createHashSignature: () => `${basePath}/hash`,
};

// Request parameters for the createHashSignature endpoint.
export interface CreateHashSignatureParams {
  public_id: string;
  tags: string;
  guestJWT?: string;
}

/**
 * Class to make calls to Weserve's Cloudinary API.
 */
// TODO: Rename to CloudinaryApi after the CloudinaryApi class is moved into the external folder
class CloudinaryWeserveApi {
  api: AxiosInstance;
  tokenHelper: TokenHelper;

  constructor(api: AxiosInstance, tokenHelper: TokenHelper) {
    this.api = api;
    this.tokenHelper = tokenHelper;
  }

  /**
   * POST /cloud-me-up/hash
   * Purpose:
   *  - Creates a signature to verify the integrity of the API connection we make to the Cloudinary API so it knows
   *  - the request we are making to their API is legitimate and not tampered with.
   * Params:
   *  - public_id: Every asset uploaded to Cloudinary is assigned a unique identifier in the form of a Public ID,
   *               which is a URL-safe string that is used to reference the uploaded resource
   *               as well as for building dynamic delivery and transformation URLs.
   *
   *  - tags: Tags are individual values that can be assigned to specific assets.
   *         We can send a single tag (ex: volunteer) or multiple tags as a string with commas (ex: cotribute,volunteer,external)
   *
   * - guestJWT: Handles the scenario where a user who was not auth'd into the app sharing a story.
   *             Since the hash endpoint requires authentication, we will need to use the token returned in the createStory endpoint
   *             in stories.ts in order to access this endpoint. This token is considered as a "Guest" token in weserve.
   */
  createHashSignature = ({
    public_id,
    tags,
    guestJWT,
  }: CreateHashSignatureParams) => {
    // Check if a guest JWT was passed into this method, otherwise check if there is currently a logged in user via local storage.
    const token = guestJWT || this.tokenHelper.getJwtToken();

    return this.api.post(
      cloudinaryWeserveApiPaths.createHashSignature(),
      {
        public_id,
        tags,
      },
      {
        headers: {
          Authorization: this.tokenHelper.formatAuthHeader(token),
        },
      }
    );
  };
}

export default CloudinaryWeserveApi;
